import { render, staticRenderFns } from "./COAHeadsReport.vue?vue&type=template&id=4c99f0e6"
import script from "./COAHeadsReport.vue?vue&type=script&lang=js"
export * from "./COAHeadsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports